import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, TextareaAutosize
} from "@material-ui/core";
import DescriptionIcon from '@mui/icons-material/Description';
import Button from '@mui/material/Button';
import React, { useState} from "react";
import axios from "axios";
import { api } from "./api/client";
import Popover from "@mui/material/Popover";
import IconButton from "@mui/material/IconButton";
let timer=0;
export default function ModalboxReddedilenNot(props) {
    const [open, setOpen] = useState(false);
    let btnColor="danger";
    const [state, setState] = useState({
        id:props.id,
        red_notlari:props.red_notlari

    });
    if(props.red_notlari) {
        btnColor="success";
    }

    const [openPop, setOpenPop] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [teklif_no, setTeklif_no] = useState(null);
    const  handlePopoverOpen = (event) => {
        setState({red_notlari:props.red_notlari, id: props.id});

        if (state.red_notlari) {
            setAnchorEl(event.currentTarget);
            timer = setTimeout(()=>{setOpenPop(true)},1000)
            setTeklif_no(event.target.id)
        }
    };

    const  handlePopoverClose = (event) => {
        setAnchorEl(null);
        setOpenPop(false);
        setTeklif_no(null)
    };

    const handleChange = name => e => {
        setState({
            ...state,
            [name]: e.target.value
        });
        console.log('state change',state);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    function onMouseLeave(){
        clearTimeout(timer)
    }
    return (
        <div>
            <IconButton variant="outlined" size={"small"}  style={{color: state.red_notlari ? "green": "red"}} onClick={handleClickOpen }
                    aria-owns={openPop ? 'mouse-over-popover' : undefined}
                    aria-haspopup="true"
                    onMouseEnter={handlePopoverOpen}
                    onMouseLeave={onMouseLeave}
                    id={props.teklifNo}
            >
                <DescriptionIcon />
            </IconButton>
            <Popover
                id="mouse-over-popover"
                sx={{
                    pointerEvents: 'auto',
                }}
                open={openPop}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                }}
            >
            <div style={{width:400}}>
                {state.red_notlari || ""}
            </div>
            </Popover>
             <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                maxWidth="md"
            >
                <DialogTitle id="form-dialog-title">Teklif Reddedilme Notu </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Notları Giriniz
                    </DialogContentText>

                    <TextareaAutosize
                        margin="dense"
                        id="red_notlari"
                        label="Notlar"
                        type="tel"
                        value={state.red_notlari || ""}
                        onChange={handleChange("red_notlari")}
                        fullWidth
                        multiline
                        minRows="8"
                        style={{ width: 400 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        İptal
                    </Button>
                    <Button
                        onClick={
                            async () => {
                             console.log(props.row);
                             await api.patch('/teklifler/' + props.id + '/iptal-notu?id=' + props.id, {
                                 'red_notlari': state.red_notlari
                             })
                                .then((response) => {
                                    // Success 🎉
                                    console.log(response);
                                    handleClose();
                                    props.reddEdilmis(true);
                                })
                                .catch((error) => {
                                    // Error 😨
                                    if (error.response) {
                                        /*
                                         * The request was made and the server responded with a
                                         * status code that falls out of the range of 2xx
                                         */
                                        console.log(error.response.data);
                                        console.log(error.response.status);
                                        console.log(error.response.headers);
                                    } else if (error.request) {
                                        /*
                                         * The request was made but no response was received, `error.request`
                                         * is an instance of XMLHttpRequest in the browser and an instance
                                         * of http.ClientRequest in Node.js
                                         */
                                        console.log(error.request);
                                    } else {
                                        // Something happened in setting up the request and triggered an Error
                                        console.log('Error', error.message);
                                    }
                                    console.log(error.config);
                                });
                            setState({open:false});
                        }}
                        color="primary"
                    >
                        Kaydet
                    </Button>
                </DialogActions>
            </Dialog></div>
    )
}

